<script>
	import './style.scss'

  export default {
    name: 'enter-email'
  }

</script>

<template>
  <div class="enter-email">
    <a href='#subscribe'>
      <button class='cta mobile'>
        <strong>Enter Email</strong> To Get Daily Questions
      </button>
    </a>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/EnterEmailButton/EnterEmailButton.vue